import styled from "styled-components";

export const Container = styled.div`
  padding: 16px;
`;

export const StyledButton = styled.button`
  padding: 4px;
`;
